export default __webpack_public_path__ + "static/media/img_about8@2x.min.94eb437e.jpg";